<template>
  <div
    v-if="!lodash.isEmpty(contactsInfo)"
    class="vr-appoint-compo"
  >
    <!-- 带看按钮 -->
    <van-image
      :class="['vr-icon', showContacts ? 'show' : 'hide']"
      width="68px"
      :src="require('@/imgs/vr_btn.png')"
      :show-error="false"
      :show-loading="false"
      @click="showContacts = true;"
    />
    <!-- 联系人 -->
    <van-popup
      v-model="showContacts"
      position="bottom"
      round
      class="contacts"
      :style="{ height: '60%' }"
    >
      <div class="title flx-col-ctr">
        选择顾问发起带看
      </div>
      <div class="content-view">
        <template v-for="(item, index) in contactsInfo">
          <div
            :key="index"
            class="content flx-ctr"
          >
            <span
              class="avatar"
            >
              <img :src="item.img">
            </span>
            <span
              class="text flx-col-ctr"
              style="margin-right: 3.6rem"
            >
              <span>{{ item.title }}</span>
              <span style="margin-top: 10px">{{ item.name }}</span>
            </span>
            <span
              class="call-btn flx-ctr"
              @click="phoneCall(item.phone)"
            >呼叫</span>
          </div>
          <div
            :key="`split-${index}`"
            class="split"
          />
        </template>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    contactsInfo: {
      type: Array,
      default() {
        // {
        //   title: '销售经理',
        //   name: '',
        //   company: '',
        //   img: require('@/imgs/contacts/01.jpg'),
        //   phone: '',
        // }
        return [];
      },
    },
  },
  data() {
    return {
      showContacts: false,
    };
  },
};
</script>

<style lang="less" scope>
.vr-appoint-compo {
  .vr-icon {
    position: fixed;
    bottom: 45vh;
    right: 0;
    z-index: 100;
  }
  .contacts {
    .title {
      width: 100%;
      height: 44px;
      color: #8b8b8c;
    }
    .split {
      width: 90%;
      height: 1px;
      margin: 14px 0 14px 5%;
      background-color: #e1e2e2;
    }
    .content-view {
      width: 100%;
      height: calc(100% - 44px);
      overflow-y: scroll;
      color: #8b8b8c;
      font-size: 15px;
      .avatar {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 20%;
        img {
          width: 58px;
          height: 58px;
          border-radius: 50%;
        }
      }
      .content {
        width: 10rem;
        // height: 54px;
        .text {
          align-items: flex-start;
        }
      }
      .call-btn {
        width: 2rem;
        height: .8rem;
        color: #f4f4f4;
        border-radius: 50px;
        background-image: linear-gradient(to bottom, #1b1b1b , #5c5c5c);
      }
    }
  }

}
</style>
